import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { buildRedirectUrl } from '../lib/redirectUrl';

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return <div role="status" aria-label="Loading" aria-busy="true" style={{ padding: 16 }}>Loading…</div>;
  }
  if (!user) {
    const next = `${loc.pathname}${loc.search}${loc.hash}`;
    const redirectUrl = `/auth/signin?next=${encodeURIComponent(next)}`;
    return <Navigate to={redirectUrl} replace />;
  }
  return <>{children}</>;
}